function code(id, message) {
    return {
        id : id, message : message
    };
}

var ResponseCode = {
    OK :                                code(100, "Connected successfully"),
    DOWNGRADE :                         code(102, "Server does not support the requested protocol level"),
    RECONNECTED :                       code(105, "Reconnected successfully"),
    RECONNECTED_WITH_MESSAGE_LOSS :     code(106, "Reconnected with message loss"),
    REJECTED :                          code(111, "Connection rejected"),
    CONNECTION_UNSUPPORTED :            code(112, "Connection type not supported by connector"),
    LICENSE_EXCEEDED :                  code(113, "Connection rejected due to license limit"),
    RECONNECTION_UNSUPPORTED :          code(114, "Reconnection not supported by connector"),
    CONNECTION_PROTOCOL_ERROR :         code(115, "Connection failed - protocol error"),
    AUTHENTICATION_FAILED :             code(116, "Connection failed - authentication failed"),
    UNKNOWN_SESSION :                   code(117, "Reconnection failed - the session is unknown"),
    RECONNECTION_FAILED_MESSAGE_LOSS :  code(118, "Reconnection failed due to message loss"),
    ERROR :                             code(127, "Connection failed due to server error")
};

ResponseCode.isSuccess = function isSuccess(code) {
    switch (code) {
        case ResponseCode.OK :
        case ResponseCode.RECONNECTED :
        case ResponseCode.RECONNECTED_WITH_MESSAGE_LOSS :
            return true;
        default :
            return false;
    }
};

module.exports = ResponseCode;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/protocol/response-code.js
// module id = 158
// module chunks = 1